// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate } from "react-router-dom";
// import "./UploadSchoolNotes.css";

// const SchoolNotes = () => {
//   const [boards, setBoards] = useState([]);
//   const [boardId, setBoardId] = useState("");

//   const [schoolClassName, setSchoolClassName] = useState([]);
//   const [schoolClassNameId, setSchoolClassNameId] = useState("");
//   const [subjects, setSubjects] = useState([]);
//   const [subjectId, setSubjectId] = useState("");

//   const [noteTitle, setNoteTitle] = useState("");
//   const [file, setFile] = useState(null);
//   const [language, setLanguage] = useState("");

//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
//   const navigate = useNavigate();

//   /* =======================
//      FETCH BOARDS
//   ======================= */
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/boards`)
//       .then((res) => setBoards(res.data.data))
//       .catch(console.log);
//   }, []);

//   /* =======================
//      FETCH CLASSES
//   ======================= */
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/classes`)
//       .then((resp) => setSchoolClassName(resp.data.data))
//       .catch(console.log);
//   }, []);

//   /* =======================
//      FETCH SUBJECTS
//   ======================= */
//   useEffect(() => {
//     if (schoolClassNameId) {
//       axios
//         .get(`${API_BASE_URL}/subjects/?reference=${schoolClassNameId}`)
//         .then((res) => setSubjects(res.data.data))
//         .catch(console.log);
//     }
//   }, [schoolClassNameId]);

//   /* =======================
//      SUBMIT NOTES
//   ======================= */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!boardId) {
//       alert("Please select board");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("boardId", boardId);
//     formData.append("noteTitle", noteTitle);
//     formData.append("language", language);
//     formData.append("schoolSubjectId", subjectId);
//     formData.append("noteFile", file);

//     axios
//       .post(`${API_BASE_URL}/admin/notes`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then(() => {
//         alert("Note uploaded successfully!");
//         navigate("/upload-notes/all-school-notes");
//       })
//       .catch((error) => {
//         console.error(error);
//         alert("Error uploading note");
//       });
//   };

//   const handleAddNewNote = () => {
//     navigate("/upload-notes/upload-school-notes");
//   };

//   const handleViewAllNotes = () => {
//     navigate("/upload-notes/all-school-notes");
//   };

//   const handleGoBack = () => navigate("/upload-notes/upload-all-notes");

//   return (
//     <div id="exam-school-notes-inner-wrapper">
//       <div className="main-header">
//         <BiArrowBack
//           onClick={handleGoBack}
//           className="left-arrow-icon"
//           style={{ cursor: "pointer", fontSize: "25px" }}
//         />
//         <div className="exam-header-div">
//           <h5>School Notes</h5>
//           <div className="exam-btn-group">
//             <button className="addNewNoteBtn" onClick={handleAddNewNote}>
//               + Upload Notes
//             </button>
//             <button className="viewAllNotesBtn" onClick={handleViewAllNotes}>
//               All Notes
//             </button>
//           </div>
//         </div>

//         <div className="form-container">
//           <h4 className="note-detail">Note Details</h4>

//           <form onSubmit={handleSubmit} className="note-detail-form">

//             {/* BOARD */}
//             <div className="input-group">
//               <label className="label">Board</label>
//               <select
//                 value={boardId}
//                 onChange={(e) => setBoardId(e.target.value)}
//                 required
//               >
//                 <option value="">- Select Board -</option>
//                 {boards.map((b) => (
//                   <option key={b._id} value={b._id}>
//                     {b.boardName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* CLASS */}
//             <div className="input-group">
//               <label className="label">Class Name</label>
//               <select
//                 value={schoolClassNameId}
//                 onChange={(e) => setSchoolClassNameId(e.target.value)}
//                 required
//               >
//                 <option value="">- Select Class -</option>
//                 {schoolClassName.map((c) => (
//                   <option key={c._id} value={c._id}>
//                     {c.className}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* SUBJECT */}
//             <div className="input-group">
//               <label className="label">Subject Name</label>
//               <select
//                 value={subjectId}
//                 onChange={(e) => setSubjectId(e.target.value)}
//                 required
//               >
//                 <option value="">- Select Subject -</option>
//                 {subjects.map((s) => (
//                   <option key={s._id} value={s._id}>
//                     {s.subjectName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* TITLE */}
//             <div className="input-group">
//               <label className="label">Note Title</label>
//               <input
//                 type="text"
//                 value={noteTitle}
//                 onChange={(e) => setNoteTitle(e.target.value)}
//                 required
//               />
//             </div>

//             {/* LANGUAGE */}
//             <div className="input-group">
//               <label className="label">Language</label>
//               <label>
//                 <input
//                   type="radio"
//                   value="hindi"
//                   checked={language === "hindi"}
//                   onChange={(e) => setLanguage(e.target.value)}
//                 /> Hindi
//               </label>
//               <label style={{ marginLeft: "15px" }}>
//                 <input
//                   type="radio"
//                   value="english"
//                   checked={language === "english"}
//                   onChange={(e) => setLanguage(e.target.value)}
//                 /> English
//               </label>
//             </div>

//             {/* FILE */}
//             <div className="input-group">
//               <label className="label">Upload PDF</label>
//               <input
//                 type="file"
//                 accept=".pdf"
//                 onChange={(e) => setFile(e.target.files[0])}
//                 required
//               />
//             </div>

//             <div className="form1-btns">
//               <button className="btn-save">Save</button>
//               <button type="button" className="btn-cancel" onClick={handleGoBack}>
//                 Cancel
//               </button>
//             </div>

//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SchoolNotes;












import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import "./UploadSchoolNotes.css";

const SchoolNotes = () => {

  const [boards, setBoards] = useState([]);
  const [boardId, setBoardId] = useState("");

  const [schoolClassName, setSchoolClassName] = useState([]);
  const [schoolClassNameId, setSchoolClassNameId] = useState("");

  const [subjects, setSubjects] = useState([]);
  const [subjectId, setSubjectId] = useState("");

  const [noteTitle, setNoteTitle] = useState("");
  const [file, setFile] = useState(null);

  const [videoUrl, setVideoUrl] = useState(""); // ✅ NEW

  const [language, setLanguage] = useState("");

  const API_BASE_URL =
    process.env.REACT_APP_API_BASEURL;

  const navigate = useNavigate();



  /* ================= FETCH BOARDS ================= */
  useEffect(() => {

    axios
      .get(`${API_BASE_URL}/boards`)
      .then((res) =>
        setBoards(res.data.data)
      )
      .catch(console.log);

  }, []);



  /* ================= FETCH CLASSES ================= */
  useEffect(() => {

    axios
      .get(`${API_BASE_URL}/classes`)
      .then((resp) =>
        setSchoolClassName(resp.data.data)
      )
      .catch(console.log);

  }, []);



  /* ================= FETCH SUBJECTS ================= */
  useEffect(() => {

    if (schoolClassNameId) {

      axios
        .get(
          `${API_BASE_URL}/subjects/?reference=${schoolClassNameId}`
        )
        .then((res) =>
          setSubjects(res.data.data)
        )
        .catch(console.log);

    }

  }, [schoolClassNameId]);



  /* ================= FILE CHANGE ================= */
  const handleFileChange = (e) => {

    const selectedFile =
      e.target.files[0];

    if (
      selectedFile &&
      selectedFile.type !==
      "application/pdf"
    ) {

      alert(
        "Only PDF files allowed"
      );

      return;

    }

    setFile(selectedFile);

  };



  /* ================= SUBMIT ================= */
  // const handleSubmit = (e) => {

  //   e.preventDefault();


  //   if (!boardId) {

  //     alert("Please select board");

  //     return;

  //   }


  //   if (!file && !videoUrl) {

  //     alert(
  //       "Please upload PDF or enter video URL"
  //     );

  //     return;

  //   }


  //   const formData =
  //     new FormData();

  //   formData.append(
  //     "boardId",
  //     boardId
  //   );

  //   formData.append(
  //     "noteTitle",
  //     noteTitle
  //   );

  //   formData.append(
  //     "language",
  //     language
  //   );

  //   formData.append(
  //     "schoolSubjectId",
  //     subjectId
  //   );


  //   if (file)
  //     formData.append(
  //       "noteFile",
  //       file
  //     );


  //   if (videoUrl)
  //     formData.append(
  //       "videoUrl",
  //       videoUrl
  //     );



  //   axios
  //     .post(
  //       `${API_BASE_URL}/admin/notes`,
  //       formData,
  //       {
  //         headers: {
  //           Authorization:
  //             `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     )
  //     .then(() => {

  //       alert(
  //         "Note uploaded successfully!"
  //       );

  //       navigate(
  //         "/upload-notes/all-school-notes"
  //       );

  //     })
  //     .catch((error) => {

  //       console.error(error);

  //       alert(
  //         error.response?.data?.msg ||
  //         "Error uploading note"
  //       );

  //     });

  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!boardId) {
      alert("Please select board");
      return;
    }

    if (!file && !videoUrl) {
      alert("Please upload PDF or enter video URL");
      return;
    }

    const formData = new FormData();

    formData.append("boardId", boardId);
    formData.append("noteTitle", noteTitle);
    formData.append("language", language);
    formData.append("schoolSubjectId", subjectId);

    if (file) formData.append("noteFile", file);
    if (videoUrl) formData.append("videoUrl", videoUrl);

    const role = localStorage.getItem("role");
    // decide endpoint based on role
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/notes`
        : `${API_BASE_URL}/admin/notes`;

    axios
      .post(endpoint, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        alert("Note uploaded successfully!");
        navigate("/upload-notes/all-school-notes");
      })
      .catch((error) => {
        console.error(error);
        alert(error.response?.data?.msg || "Error uploading note");
      });
  };



  const handleAddNewNote =
    () =>
      navigate(
        "/upload-notes/upload-school-notes"
      );


  const handleViewAllNotes =
    () =>
      navigate(
        "/upload-notes/all-school-notes"
      );


  const handleGoBack =
    () =>
      navigate(
        "/upload-notes/upload-all-notes"
      );



  return (

    <div id="exam-school-notes-inner-wrapper">

      <div className="main-header">

        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            fontSize: "25px",
          }}
        />



        <div className="exam-header-div">

          <h5>School Notes</h5>

          <div className="exam-btn-group">

            <button
              className="addNewNoteBtn"
              onClick={
                handleAddNewNote
              }
            >
              + Upload Notes
            </button>


            <button
              className="viewAllNotesBtn"
              onClick={
                handleViewAllNotes
              }
            >
              All Notes
            </button>

          </div>

        </div>



        <div className="form-container">

          <h4 className="note-detail">
            Note Details
          </h4>



          <form
            onSubmit={
              handleSubmit
            }
            className="note-detail-form"
          >



            {/* BOARD */}
            <div className="input-group">

              <label>
                Board
              </label>

              <select
                value={
                  boardId
                }
                onChange={(e) =>
                  setBoardId(
                    e.target.value
                  )
                }
                required
              >

                <option value="">
                  Select Board
                </option>

                {boards.map(
                  (b) => (

                    <option
                      key={
                        b._id
                      }
                      value={
                        b._id
                      }
                    >
                      {
                        b.boardName
                      }
                    </option>

                  )
                )}

              </select>

            </div>



            {/* CLASS */}
            <div className="input-group">

              <label>
                Class Name
              </label>

              <select
                value={
                  schoolClassNameId
                }
                onChange={(e) =>
                  setSchoolClassNameId(
                    e.target.value
                  )
                }
                required
              >

                <option value="">
                  Select Class
                </option>

                {schoolClassName.map(
                  (c) => (

                    <option
                      key={
                        c._id
                      }
                      value={
                        c._id
                      }
                    >
                      {
                        c.className
                      }
                    </option>

                  )
                )}

              </select>

            </div>



            {/* SUBJECT */}
            <div className="input-group">

              <label>
                Subject
              </label>

              <select
                value={
                  subjectId
                }
                onChange={(e) =>
                  setSubjectId(
                    e.target.value
                  )
                }
                required
              >

                <option value="">
                  Select Subject
                </option>

                {subjects.map(
                  (s) => (

                    <option
                      key={
                        s._id
                      }
                      value={
                        s._id
                      }
                    >
                      {
                        s.subjectName
                      }
                    </option>

                  )
                )}

              </select>

            </div>



            {/* TITLE */}
            <div className="input-group">

              <label>
                Note Title
              </label>

              <input
                type="text"
                value={
                  noteTitle
                }
                onChange={(e) =>
                  setNoteTitle(
                    e.target.value
                  )
                }
                required
              />

            </div>



            {/* LANGUAGE */}
            <div className="input-group">

              <label>
                Language
              </label>

              <label>

                <input
                  type="radio"
                  value="hindi"
                  checked={
                    language ===
                    "hindi"
                  }
                  onChange={(e) =>
                    setLanguage(
                      e.target.value
                    )
                  }
                />

                Hindi

              </label>


              <label
                style={{
                  marginLeft:
                    "15px",
                }}
              >

                <input
                  type="radio"
                  value="english"
                  checked={
                    language ===
                    "english"
                  }
                  onChange={(e) =>
                    setLanguage(
                      e.target.value
                    )
                  }
                />

                English

              </label>

            </div>



            {/* PDF */}
            <div className="input-group">

              <label>
                Upload PDF
              </label>

              <input
                type="file"
                accept=".pdf"
                onChange={
                  handleFileChange
                }
              />

            </div>



            {/* VIDEO URL */}
            <div className="input-group">

              <label>
                YouTube Video URL
              </label>

              <input
                type="text"
                placeholder="Enter YouTube link"
                value={
                  videoUrl
                }
                onChange={(e) =>
                  setVideoUrl(
                    e.target.value
                  )
                }
              />

            </div>



            {/* BUTTONS */}
            <div className="form1-btns">

              <button className="btn-save">
                Save
              </button>


              <button
                type="button"
                className="btn-cancel"
                onClick={
                  handleGoBack
                }
              >
                Cancel
              </button>

            </div>



          </form>

        </div>

      </div>

    </div>

  );

};

export default SchoolNotes;
